import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const HelpPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="container mx-auto px-4 py-12 max-w-2xl">
      <button
        className="mb-6 flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
        onClick={() => navigate(-1)}
        aria-label="Back"
      >
        <ArrowLeft className="w-5 h-5" />
        Back
      </button>
      <h1 className="text-3xl font-bold mb-4">Help & Support</h1>
      <p className="mb-6 text-muted-foreground">
        Welcome to the Myǃhū Help Center. Here you can find answers to common
        questions, troubleshooting tips, and ways to contact support.
      </p>
      <h2 className="text-xl font-semibold mt-8 mb-2">
        Frequently Asked Questions
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>How do I purchase credits?</li>
        <li>How do I invite guests?</li>
        <li>How do I access my reports?</li>
        <li>How do I contact support?</li>
      </ul>
      <h2 className="text-xl font-semibold mt-8 mb-2">Contact Support</h2>
      <p>
        If you need further assistance, please email us at
        <a href="mailto:support@myhu.world" className="underline ml-1">
          support@myhu.world
        </a>
        .
      </p>
    </div>
  );
};

export default HelpPage;
